import { InjectionToken } from '@angular/core';

export const LOCATION = new InjectionToken<Location>('LOCATION');
